var _path, _path2, _line, _line2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C1.44772 1 1 1.44772 1 2V8L15 8V2C15 1.44772 14.5523 1 14 1H2ZM15 9L1 9V15C1 15.5523 1.44772 16 2 16H14C14.5523 16 15 15.5523 15 15V9Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5L3.9375 5.5L3 4.59091",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 4.5,
    x2: 12.5,
    y2: 4.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 12.5,
    x2: 12.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66891 11.1148C3.5159 10.9618 3.26783 10.9618 3.11482 11.1148C2.96181 11.2678 2.96181 11.5159 3.11482 11.6689L3.94592 12.5L3.11476 13.3311C2.96175 13.4841 2.96175 13.7322 3.11476 13.8852C3.26777 14.0382 3.51584 14.0382 3.66885 13.8852L4.50002 13.0541L5.3312 13.8852C5.48421 14.0383 5.73228 14.0383 5.88529 13.8852C6.0383 13.7322 6.0383 13.4842 5.88529 13.3311L5.05412 12.5L5.88523 11.6689C6.03824 11.5158 6.03824 11.2678 5.88523 11.1148C5.73222 10.9617 5.48415 10.9617 5.33114 11.1148L4.50002 11.9459L3.66891 11.1148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.ebe89895.svg";
export { ForwardRef as ReactComponent };